import { render, staticRenderFns } from "./superPrint.vue?vue&type=template&id=20d3da10&scoped=true&"
import script from "./superPrint.vue?vue&type=script&lang=js&"
export * from "./superPrint.vue?vue&type=script&lang=js&"
import style0 from "./superPrint.vue?vue&type=style&index=0&id=20d3da10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3da10",
  null
  
)

export default component.exports